var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestionMark = function SvgQuestionMark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916992 11C0.916992 5.43113 5.43145 0.916664 11.0003 0.916664C16.5692 0.916664 21.0837 5.43113 21.0837 11C21.0837 16.5689 16.5692 21.0833 11.0003 21.0833C5.43145 21.0833 0.916992 16.5689 0.916992 11ZM11.0003 2.75C6.44398 2.75 2.75033 6.44365 2.75033 11C2.75033 15.5563 6.44398 19.25 11.0003 19.25C15.5567 19.25 19.2503 15.5563 19.2503 11C19.2503 6.44365 15.5567 2.75 11.0003 2.75Z",
    fill: "#006FDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 17.4167C11.5069 17.4167 11.9173 17.0063 11.9173 16.5C11.9173 15.9937 11.5069 15.5833 11.0007 15.5833C10.4944 15.5833 10.084 15.9937 10.084 16.5C10.084 17.0063 10.4944 17.4167 11.0007 17.4167Z",
    fill: "#006FDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29974 5.53533C9.1143 4.86887 10.1291 4.58333 11 4.58333C11.9143 4.58333 12.9096 4.95253 13.6803 5.54809C14.4549 6.14663 15.125 7.07603 15.125 8.24999C15.125 9.24441 14.8345 10.0232 14.3512 10.6273C13.8853 11.2098 13.2884 11.5681 12.7849 11.8199C12.0764 12.1742 11.9167 12.5944 11.9167 12.8333C11.9167 13.3396 11.5063 13.75 11 13.75C10.4937 13.75 10.0833 13.3396 10.0833 12.8333C10.0833 11.6972 10.8403 10.7425 11.9651 10.1801C12.3782 9.97351 12.6981 9.75898 12.9196 9.48205C13.1238 9.22683 13.2917 8.85975 13.2917 8.24999C13.2917 7.8198 13.0451 7.37419 12.5593 6.99878C12.0696 6.62038 11.4607 6.41666 11 6.41666C10.4959 6.41666 9.90653 6.58946 9.46068 6.95425C9.04343 7.29563 8.70833 7.83722 8.70833 8.70833C8.70833 9.21459 8.29793 9.625 7.79167 9.625C7.28541 9.625 6.875 9.21459 6.875 8.70833C6.875 7.28777 7.45657 6.22519 8.29974 5.53533Z",
    fill: "#006FDE"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question-mark.ec77feab.svg";
export { ForwardRef as ReactComponent };